module.exports = __webpack_public_path__ + "assets/img/network-2.327612f3.svg";